import { Layout } from "antd";
import { useTranslation } from "react-i18next";

import WidgetsGrid from "@/components/Elements/WidgetsGrid";
import BaseHeader from "@/components/Header/BaseHeader";
import { PROJECTS_STATISTICS_WIDGETS } from "@/components/ListStatistics/Projects";
import ProjectsTable from "@/components/ListTable/ProjectsTable";
import { STORAGE_KEYS } from "@/constants/StorageKeys";
import { ListProvider } from "@/modules/list";
import ProjectAddButton from "@/modules/project/project-add-button";

const { Content } = Layout;

const Projects = () => {
  const { t } = useTranslation();

  return (
    <>
      <BaseHeader
        title={t("navigation:projects")}
        extra={[<ProjectAddButton key="project-add-button" />]}
      />
      <Content>
        <ListProvider
          endpoint="projects"
          storageKey={STORAGE_KEYS.PROJECTS}
          withMetadata={["statistics"]}
          withContext
        >
          <WidgetsGrid widgets={PROJECTS_STATISTICS_WIDGETS}>
            <ProjectsTable showLocationColumn />
          </WidgetsGrid>
        </ListProvider>
      </Content>
    </>
  );
};

export default Projects;
